export const CertificateIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M30 37.5C30 39.4891 30.7902 41.3968 32.1967 42.8033C33.6032 44.2098 35.5109 45 37.5 45C39.4891 45 41.3968 44.2098 42.8033 42.8033C44.2098 41.3968 45 39.4891 45 37.5C45 35.5109 44.2098 33.6032 42.8033 32.1967C41.3968 30.7902 39.4891 30 37.5 30C35.5109 30 33.6032 30.7902 32.1967 32.1967C30.7902 33.6032 30 35.5109 30 37.5Z"
                stroke="url(#paint0_linear_973_24371)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M32.5 43.75V55L37.5 51.25L42.5 55V43.75" stroke="url(#paint1_linear_973_24371)" strokeWidth="4"
                  strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M25 47.5H12.5C11.1739 47.5 9.90215 46.9732 8.96447 46.0355C8.02678 45.0979 7.5 43.8261 7.5 42.5V17.5C7.5 14.75 9.75 12.5 12.5 12.5H47.5C48.8261 12.5 50.0979 13.0268 51.0355 13.9645C51.9732 14.9021 52.5 16.1739 52.5 17.5V42.5C52.4991 43.3768 52.2676 44.238 51.8288 44.9971C51.3901 45.7562 50.7593 46.3866 50 46.825M15 22.5H45M15 30H22.5M15 37.5H20"
                stroke="url(#paint2_linear_973_24371)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            <defs>
                <linearGradient id="paint0_linear_973_24371" x1="38.5345" y1="21.6176" x2="59.0963" y2="53.7237"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
                <linearGradient id="paint1_linear_973_24371" x1="38.1897" y1="37.4632" x2="54.2944" y2="59.8158"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
                <linearGradient id="paint2_linear_973_24371" x1="33.1034" y1="-7.05882" x2="75.2638" y2="77.581"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
            </defs>
        </svg>
    );
};